import type { FlatpickrFn } from "flatpickr/dist/types/instance";

export class Flatpickr
{
	constructor()
	{
	}

	static async Import(): Promise<FlatpickrFn>
	{
		const FlatpickrPromise = new Promise<FlatpickrFn>((resolve, reject) =>
		{
			import(/* webpackChunkName: "FlatpickrImport" */"./Imports/_Flatpickr")
				.then((flatpickr) =>
				{
					const instance = flatpickr.default;

					instance.setDefaults({
						nextArrow: `<svg class="svg-inline--fa" aria-hidden="true"><use xlink:href="#fa-solid-fa-chevron-right"></use></svg>`,
						prevArrow: `<svg class="svg-inline--fa" aria-hidden="true"><use xlink:href="#fa-solid-fa-chevron-left"></use></svg>`,
						altInput: true,
						altFormat: "F j, Y",
						dateFormat: "F j, Y"
					});

					resolve(instance);
				})
				.catch((error) =>
				{
					console.log(error);
					reject("error");
				});
		});

		return FlatpickrPromise;
	}
}